import React, { useEffect, useRef, useState } from 'react';
import Modal from './Modal';

// Bump this version to re-show the notice to every user (e.g. 'v2').
const MAINTENANCE_NOTICE_VERSION = 'v1';
const STORAGE_KEY = 'agv_maintenance_notice_dismissed';

function isDismissed() {
  try {
    return localStorage.getItem(STORAGE_KEY) === MAINTENANCE_NOTICE_VERSION;
  } catch (error) {
    return false;
  }
}

function persistDismissed() {
  try {
    localStorage.setItem(STORAGE_KEY, MAINTENANCE_NOTICE_VERSION);
  } catch (error) {
    // Ignore storage failures (e.g. private mode); the notice just reappears next load.
  }
}

export default function MaintenanceNotice() {
  const [visible, setVisible] = useState(() => !isDismissed());
  const closeButtonRef = useRef(null);

  useEffect(() => {
    if (!visible) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        handleClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    if (closeButtonRef.current) {
      closeButtonRef.current.focus();
    }

    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [visible]);

  const handleClose = () => {
    persistDismissed();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Modal>
      <div
        className="fixed inset-0 z-[2000] flex items-center justify-center bg-black/60 p-4"
        role="dialog"
        aria-modal="true"
        aria-labelledby="maintenance-notice-title"
      >
        <div className="w-full max-w-lg max-h-[90vh] overflow-auto rounded-lg bg-white p-6 shadow-xl">
          <h2
            id="maintenance-notice-title"
            className="mb-4 text-center text-lg font-semibold text-gray-800"
          >
            Maintenance / Mantención
          </h2>

          <p className="mb-3 text-sm text-gray-700">
            We are currently in the process of maintaining our digital infrastructure. Some services
            may not be working as usual. We appreciate your understanding.
          </p>
          <p className="mb-3 text-sm font-medium text-gray-700">— The AgViewer.com Team</p>

          <hr className="my-4 border-gray-200" />

          <p className="mb-3 text-sm text-gray-700">
            Estamos en proceso de mantención de nuestra infraestructura digital. Puede que los
            servicios no estén funcionando de manera usual. Agradecemos su comprensión.
          </p>
          <p className="mb-6 text-sm font-medium text-gray-700">— El equipo de AgViewer.com</p>

          <div className="text-center">
            <button
              ref={closeButtonRef}
              type="button"
              onClick={handleClose}
              className="k-button k-button-md k-button-solid k-button-solid-primary k-rounded-md"
            >
              Close / Cerrar
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
